import { createFileRoute, Link } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'
import useStore from '@/hooks/useStore.js'
import useView from '@/hooks/useView.js'
import { useEffect } from 'react'
import { LoadingIndicator, LoadingIndicatorTitle } from '@/components/ui/loadingIndicator.jsx'
import Icon from '@mdi/react'
import { mdiPostOutline } from '@mdi/js'
import { Button } from '@/components/ui/button.jsx'
import UserProfileBackground from '@/components/user/userProfileBackground.jsx'
import Post from '@/components/post/post.jsx'

const PostPage = () => {
  const { routerStore } = useStore()
  const { postView } = useView()

  useEffect(() => {
    postView.init().then()

    return () => {
      postView.reset()
    }
  }, [postView, routerStore.path])

  if (!postView.isInitialized)
    return (
      <LoadingIndicator>
        <LoadingIndicatorTitle>Loading...</LoadingIndicatorTitle>
      </LoadingIndicator>
    )

  if (!postView.exists)
    return (
      <div className="flex grow flex-col items-center justify-center gap-6 p-3">
        <Icon className="max-h-fit w-full max-w-32" path={mdiPostOutline} size="100%" />

        <h1 className="text-center text-xl">Post does not exist</h1>

        <Button asChild>
          <Link to={routerStore.routes.index}>Go Home</Link>
        </Button>
      </div>
    )

  return (
    <>
      <UserProfileBackground user={postView.post.user} />

      <div className="animate-in fade-in mx-auto w-full max-w-3xl duration-1000">
        <Post
          className="animate-in slide-in-from-bottom-3 my-6 duration-1000"
          post={postView.post}
        />
      </div>
    </>
  )
}

export const Route = createFileRoute('/post/$id')({
  component: observer(PostPage),
})
